import { useTranslation } from 'react-i18next';
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';

import { formatDayAndTime } from 'support/helpers/dateTime/dateTime';
import { MessageV2DTO, UserDTO } from 'support/types';
import { Button } from 'components/Form/Button/Button';
import { Textarea } from 'components/Form/Input/Textarea/Textarea';

type ReviewComment = NonNullable<MessageV2DTO['review']>['comments'][number];
type PendingReviewCommentProps = {
  isEditing: boolean;
  comment: ReviewComment | undefined;
  onCommentChange: (comment: ReviewComment) => void;
  toggleIsEditing: () => void;
  onDelete: () => void;
  disabled: boolean;
  currentUser: UserDTO;
};
export const PendingReviewComment = ({
  isEditing,
  comment,
  toggleIsEditing,
  onCommentChange,
  onDelete,
  disabled,
  currentUser,
}: PendingReviewCommentProps) => {
  const { t } = useTranslation();

  return (
    <div>
      {isEditing ? (
        <Textarea
          placeholder={t('transactions:show.sections.alert.review.comment.placeholder')}
          value={comment?.content}
          onChange={(e) =>
            onCommentChange({
              id: '',
              content: e.target.value,
              commented_by: currentUser,
              commented_at: comment?.commented_at || new Date().toISOString(),
            })
          }
          name="pendingReviewComment"
        />
      ) : comment ? (
        <div className="rounded-md border border-gray-200 bg-white px-4 py-3">
          <span className="text-xs text-gray-500">
            {t('transactions:show.sections.alert.review.comment.title', {
              author: comment.commented_by?.name,
              date: formatDayAndTime(comment.commented_at),
            })}
          </span>
          <div className="flex items-center justify-between gap-2">
            <p>{comment?.content}</p>
            <div className="flex items-start justify-end gap-2">
              <Button
                analyticsId="pending-review-banner-edit-comment"
                variant="secondary"
                size="small"
                LeftIcon={PencilSquareIcon}
                onClick={toggleIsEditing}
                disabled={disabled}
              >
                {t('transactions:show.sections.alert.review.comment.edit')}
              </Button>
              <Button
                analyticsId="pending-review-banner-delete-comment"
                variant="secondary"
                size="small"
                LeftIcon={TrashIcon}
                iconOnly
                onClick={onDelete}
                disabled={disabled}
              >
                {t('transactions:show.sections.alert.review.comment.delete')}
              </Button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
